import React from 'react';
import { Image } from 'src/ui/components';
import { ActionButton } from 'src/ui/components';
import { weiToEther } from 'src/base/utils';

export default function YourRewardsTabRegularMode({ claimableTotal, keysQty, onClaimAllClick, paused }){

	const claimableTotalDisplay = `${Number( weiToEther( String( claimableTotal ) ) ).toFixed( 5 )} ETH`;

	return <div className='mt-12 flex justify-center w-auto max-[700px]:mt-0'>
		<div className='flex justify-start items-center max-[700px]:flex-col  max-[700px]:w-full'>
			<Image 	
				src="/images/key.png" 
				width={153} 
				height={127}
				className='w-[71px] h-[86px] max-[700px]:w-[127px] max-[700px]:h-[153px] max-[700px]:mt-[44px] max-[700px]:mb-[20px] '
			/>
			<div className='flex  max-[700px]:justify-center max-[700px]:mb-4'>
				<div className='flex flex-col items-center ml-[86px] max-[800px]:ml-[50px]  max-[700px]:ml-[40px]'> 
					<span className='mb-4 text-[#B3FE00] uppercase font-semibold text-base'>keys</span> 
					<span className="text-[40px] font-bold -f-family-burbank uppercase text-white">{keysQty}</span>
				</div>

				<div className='flex flex-col items-center mx-[100px] max-[800px]:mx-[60px] [700px]:mx-[0px] '> 
					<span className='mb-4 text-[#B3FE00] uppercase font-semibold text-base'>Claimable</span> 
					<span className="text-[40px] font-bold -f-family-burbank uppercase text-white">{claimableTotalDisplay}</span>
				</div>
			</div>

			<ActionButton className='w-[142px] h-[64px] text-[32px] '
				textContent="claim"
				disabled={paused}
				onClick={onClaimAllClick}/>

		</div>
	</div>;
}
